__webpack_require__.p = "https://uat.prof.byonde.asia/";